import React, { useRef } from 'react';
import CalendrierInfoReservation from "./calendrier-info-reservation";
import Guid from '../../models/Guid';

interface CalendrierReservationEnteteProps {
  idReservationEntete: Guid;
}

const CalendrierReservationEntete = ({ idReservationEntete }: CalendrierReservationEnteteProps) => {
  const infoReservationRef = useRef<any>(null);

  return (
    <div ref={infoReservationRef} style={{ height: "9.3rem" }}>
      <CalendrierInfoReservation idReservation={idReservationEntete} />
    </div>
  )
}
export default CalendrierReservationEntete;